declare namespace $ {

	export class $mol_icon_star extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=star.view.tree.d.ts.map